import axios from '../../utils/http/http';
import { triggerNotification } from '../../utils/NotificationContext';

export const fetchPortfolioDetailData = async (cardDetails, pageNo = 1, pageSize = 5) => {
  try {
    const response = await axios.getRequest(
      `/tpo/portfolioSummaryData/getPortfolioSummaryDetailData?cycleId=${cardDetails.cycleId}&quadrantName=${cardDetails.quadrantName}`
    );

    return response;
  } catch (error) {

    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw new Error(errorMessage);
  }
};

export const fetchPBIEmbedToken = async (reportId, datasetId) => {
  try {
    const response = await axios.getRequest(
      `/tpo/portfolioSummaryData/getPBIEmbedToken?reportId=${reportId}&datasetId=${datasetId}`
    );
    return response;
  } catch (error) {
    console.error(error);
    return "";
  }
}
